import { PropsWithChildren, forwardRef } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const breakpoint = {
  medium: 'min-width: 1024px',
  large: 'min-width: 1280px',
};

const Button = styled.button(({ theme }) => {
  const { type } = theme;

  return `
    display: none;

    @media screen and (${breakpoint.medium}) {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      white-space: nowrap;
      font-size: ${type.size.regular};
      font-weight: ${type.weight.bold};
      font-family: ${type.face};
    }

    @media screen and (${breakpoint.large}) {
      font-size: 1.125rem;
    }
  `;
});

const Icon = styled.span`
  display: inline-block;
  width: 18px;
  height: 18px;
  transition: transform ease-in-out 100ms;

  @media screen and (min-width: 1280px) {
    width: 24px;
    height: 24px;
  }

  &.expanded {
    transform: rotate(-180deg);
  }

  svg {
    width: 12px;
  }
`;

export interface IToggleButton {
  toggleCallback: () => void;
  extended: boolean;
}

const ToggleButton = forwardRef<HTMLButtonElement, PropsWithChildren<IToggleButton>>((props, ref) => {
  const { children, toggleCallback, extended } = props;

  return (
    <Button
      id="navToggleButton"
      type="button"
      className="navBar_toggleButton"
      aria-haspopup="true"
      aria-controls="navDropdown"
      aria-expanded={extended}
      ref={ref}
      onClick={() => {
        toggleCallback();
      }}
    >
      {children}
      <Icon className={extended ? 'expanded' : 'collapsed'}>
        <FontAwesomeIcon icon={faChevronDown} />
      </Icon>
    </Button>
  );
});
export default ToggleButton;
